import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { enableAnalytics } from "../../firebase";
import './CookieConsent.css';

const STORAGE_KEY = "afrikalink-cookie-consent";
const REOPEN_EVENT = "afrikalink-open-cookie-consent";

const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === "accepted") {
            enableAnalytics();
        } else if (stored !== "declined") {
            setVisible(true);
        }

        const reopen = () => setVisible(true);
        window.addEventListener(REOPEN_EVENT, reopen);
        return () => window.removeEventListener(REOPEN_EVENT, reopen);
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, "accepted");
        enableAnalytics();
        setVisible(false);
    };

    const decline = () => {
        localStorage.setItem(STORAGE_KEY, "declined");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-consent" role="dialog" aria-live="polite" aria-label="Cookie-Einstellungen">
            <div className="cookie-consent-text">
                <p>
                    Wir verwenden auf dieser Website neben technisch notwendigen Funktionen optional
                    Firebase Analytics, um die Nutzung unserer Website statistisch auszuwerten. Details
                    dazu finden Sie in unserer <Link to="/datenschutz">Datenschutzerklärung</Link>. Sie
                    können Ihre Auswahl jederzeit über den Link „Cookie-Einstellungen" im Footer ändern.
                </p>
            </div>
            <div className="cookie-consent-actions">
                <button className="cookie-consent-btn cookie-consent-btn--outline" onClick={decline}>
                    Nur notwendige
                </button>
                <button className="cookie-consent-btn cookie-consent-btn--primary" onClick={accept}>
                    Alle akzeptieren
                </button>
            </div>
        </div>
    );
};

export const openCookieConsent = () => {
    window.dispatchEvent(new Event(REOPEN_EVENT));
};

export default CookieConsent;
